"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * ErrorBoundary component - catches and handles React errors
 */
const react_1 = require("react");
/**
 * ErrorBoundary component that catches errors in child components
 * and displays a fallback UI instead of crashing the entire app
 */
class ErrorBoundary extends react_1.Component {
    constructor(props) {
        super(props);
        /**
         * Resets the error boundary state, allowing a retry.
         * WARNING: If the underlying error condition still exists (same props, same state),
         * the error will be thrown again immediately, potentially creating a loop.
         * Ensure the error condition has been resolved before calling this.
         */
        this.handleReset = () => {
            this.setState({
                hasError: false,
                error: null,
            });
        };
        this.state = {
            hasError: false,
            error: null,
        };
    }
    static getDerivedStateFromError(error) {
        return {
            hasError: true,
            error,
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught an error:', error, errorInfo);
        if (this.props.onError) {
            this.props.onError(error, errorInfo);
        }
    }
    render() {
        var _a;
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return ((0, jsx_runtime_1.jsx)("div", { className: "error-boundary", role: "alert", children: (0, jsx_runtime_1.jsxs)("div", { className: "error-boundary__container", children: [(0, jsx_runtime_1.jsx)("h1", { className: "error-boundary__title", children: "Something went wrong" }), (0, jsx_runtime_1.jsx)("p", { className: "error-boundary__message", children: ((_a = this.state.error) === null || _a === void 0 ? void 0 : _a.message) || 'An unexpected error occurred' }), (0, jsx_runtime_1.jsx)("button", { className: "error-boundary__button", onClick: this.handleReset, type: "button", children: "Try again" })] }) }));
        }
        return this.props.children;
    }
}
exports.ErrorBoundary = ErrorBoundary;
exports.default = ErrorBoundary;
